export const CONTACT_DETAIL_FETCH = 'CONTACT_DETAIL_FETCH';
export const CONTACT_DETAIL_SUCCESS = 'CONTACT_DETAIL_SUCCESS';
export const CONTACT_DETAIL_FAILURE = 'CONTACT_DETAIL_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/ContactDetail/actionTypes.js